import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ModelState } from 'src/app/model/model-state';
import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';

@Component({
	selector: 'app-retry-init',
	templateUrl: './retry-init.component.html',
	providers: [],
})
export class RetryInitComponent  implements OnInit, OnDestroy  {
	owned: boolean;
	configured: boolean;
	deviceSub: Subscription;
	configState: ModelState;
	initializing: boolean;
	loadingConfiguration: boolean;

	description='';

	constructor(
		private store: Store<AppState>,
		private translate: TranslateService,
	) {}

	ngOnInit(): void {
		this.deviceSub = this.store.select('device').subscribe(device => {
			this.initializing = device.initializing;
			if (device.currentDevice) {
				this.owned = device.currentDevice.CurrentlyOwned;
			}
			if (device.currentDeviceStatus) {
				this.configured = device.currentDeviceStatus.Configured === 0;
			}
			if (device.configStates && device.currentDeviceStatus) {
				this.configState = device.configStates.find(s => s.Id === device.currentDeviceStatus.Configured);
			}
			this.getDescription();
		});
		this.translate.onLangChange.subscribe(() => {
			this.getDescription();
        });
	}

	ngOnDestroy(): void {
		this.deviceSub?.unsubscribe();
	}

	canReconfigure(): boolean {
		return !this.configured && this.owned && !this.initializing;
	}

	getColorCard(): string {
		if (this.initializing) {
			return 'bg-blue-200';
		} else {
			return !this.configured ? 'bg-yellow-200' : 'bg-green-100';
		}
	}

	getDescription(): void {
		if (this.initializing) {
			this.description = this.translate.instant('LOADING_CONFIG');
		} else {
			this.description = (this.configState) ? this.translate.instant(this.configState.Description) : this.translate.instant('INIT');
		}
	}

	retryInit(): void {
		this.store.dispatch(DeviceActions.initDevice({}));
		setTimeout(() => {
			this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'new_retry_init', params: { page_title: 'Device' } }));
		}, 2000);
	}
}